<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionFields"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-list [ttData]="itemsListTravelBills"></tt-list>

        <tt-card *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="selectionFields"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-4 p-5">
            <tt-list [ttData]="itemsListTravelBills"></tt-list>

            <tt-card *ngIf="setting.show_setting === '1'">
                <tt-button-settings></tt-button-settings>
            </tt-card>
        </div>
    </div>
</tt-page>

<ng-template #selectionFields>
    <ng-container *ngIf="!!setting">
        <tt-select [hidden]="setting.labour_no !== '0'" [ttRememberId]="'travelbills' + '/' + argType + '/' + argValue + '.' + 'labour_no'" ttLabel="labour" [(ttModel)]="setting.labour_no" (ttModelChange)="onChanged($event, 'labour_no')" [ttData]="selectListLabours" ttDataId="labour_no" ttDataName="labour_name"></tt-select>
        <tt-select [hidden]="setting.labour_no === '0'" [ttRememberId]="'travelbills' + '/' + argType + '/' + argValue + '.' + 'labour_no'" ttLabel="labour" [(ttModel)]="setting.labour_no" (ttModelChange)="onChanged($event, 'labour_no')" [ttData]="selectListLabours" ttDataId="labour_no" ttDataName="labour_name" ttShowClearButton></tt-select>
        <tt-date-range [ttRememberId]="'travelbills' + '/' + argType + '/' + argValue" ttLabel="date_fom_tom" ttLabelView="top" [(ttStartDate)]="setting.date_fom" [(ttEndDate)]="setting.date_tom" [(ttInterval)]="setting.dateselector_index" (ttModelChange)="onDateRangeChanged()"></tt-date-range>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto ttText="travelbills_new" ttGoto="travelbill" [ttGotoParms]="{ argtype: setting.argtype, argvalue: setting.argvalue, travelbill_no: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        <tt-button ttText="travelbills_new_expence" (ttClick)="goToFunc('travelexpence')" ttIcon="far fa-plus"></tt-button>
    </ng-container>
</ng-template>
